import React, { FC } from 'react'
import classNames from 'classnames'

import { getStyledElementProps } from '@/utils'
import { InputTextBaseProps } from '@/types'

import styles from './text-input-base.module.scss'

export const TextInputBase: FC<InputTextBaseProps> = ({
  error = false,
  fullWidth = false,
  disabled,
  ...props
}) => {
  const styledProps = getStyledElementProps(
    props,
    classNames(styles['default'], {
      [styles['error']]: error,
      'not-allowed': disabled,
      'pui-sizing-full-width': fullWidth,
    })
  )
  return <input {...styledProps} disabled={disabled} />
}
